import React, { ReactNode, SyntheticEvent, useContext, useEffect, useState } from 'react';
import _ from 'lodash';
import { useModal } from 'hooks/useModal';
import { useSelector } from 'react-redux';
import { green } from '@mui/material/colors';
import { useHistory } from 'react-router-dom';
import makeStyles from '@mui/styles/makeStyles';
import { FormInputSelect } from 'components/form';
import { ContentViewType, ModalsKeys } from 'global';
import { useNotifications } from 'modules/notification';
import { formatCurrency, OpportunityTypes } from 'utils';
import { ModalsContainer } from 'components/shared/Modals';
import { useLazyQuery, useMutation } from '@apollo/client';
import { useVO } from 'modules/vendorOpportunity/hooks/useVO';
import { CommonDataContext } from 'contexts/CommonDataContext';
import ConfirmationDialog from 'components/ConfirmationDialog';
import EquipmentInputModal from 'components/EquipmentInputModal';
import { getSectionByReferenceType } from 'utils/ocaTemplateUtils';
import { Q_USER_DOCS } from 'pages/VendorOpportunity/DetailPages/queres';
import { useManageContact } from 'modules/creditApplicationDetails/hooks';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';
import PermContactCalendarIcon from '@mui/icons-material/PermContactCalendar';
import { portalConfigurationsSelectors } from 'redux/portalConfigurationReducer';
import { GuarantorListWithCreditPull } from 'components/GuarantorListWithCreditPull';
import { ExpandLess, ExpandMore, AddCircle, ErrorOutline } from '@mui/icons-material';
import { RenderWithCondition } from 'components/shared/Conditional/RenderWithCondition';
import { iniitialRecertificationFormValues } from 'modules/creditApplicationDetailsActions/constants';
import { AuthorizationTaskConfirmationBodyLayout } from 'modules/creditApplicationDetailsActions/ui/ContactModalLayout/FormLayout/AuthorizationTaskConfirmationBodyLayout';
import {
  Button,
  CardActions,
  CardContent,
  Collapse,
  Divider,
  Grid,
  LinearProgress,
  List,
  ListItem,
  Modal,
  Stack,
  Box,
  Typography,
} from '@mui/material';
import {
  CreditApplicationEntityType,
  CreditApplicationOwner,
  EquipmentCondition,
  FINANCING_TYPE,
  OcaTemplate,
  PaymentType,
  Reference,
  ReferenceType,
} from '@trnsact/trnsact-shared-types';
import {
  getDateTimeDisplayValue,
  getNewSignorAndGuarantorSignatureTaskForContact,
  getRecertificationTaskForContact,
} from 'services/creditAppModalService';
import {
  CorporateGuarantorModal,
  RequestRecertificationModal,
  ContactModal,
} from 'modules/creditApplicationDetailsActions';
import {
  AddContactConfirmationModalTitle,
  ContactFormValues,
  ContactPayloadInput,
  ContactType,
  RecertificationFormValues,
} from 'modules/creditApplicationDetailsActions/types';
import {
  getContactToAddGuaranteeFormValues,
  getContactToSave,
  getCreditAppInputForDocumentOrVerbalAuthorization,
  getRecertifiedCreditAppUploadFileInput,
  processFormValuesToPayload,
} from 'modules/creditApplicationDetailsActions/lib';

import { SourceRow } from './SourceRow';
import { theme } from '../../../../theme';
import { RowNameText } from './RowNameText';
import { ApplicantInfo } from './ApplicantInfo';
import { PullCreditReportRow } from './PullCreditReportRow';
import { UPDATE_CREDIT_APPLICATION_V2_QUERY, UPLOAD_FILE, UPSERT_TASK } from '../queries';
import { bpfAPI } from '../../../../modules/stages';
import { Q_CREDIT_APP, Q_VO } from '../../../../queries/common';

interface Props {
  vo: any;
  refetchVO: any;
  vp: any;
  account: any;
  equipmentData: any;
  refetchEquipment: any;
  equipmentLoading: any;
  invoiceEquipmentTabPage: any;
  userProfile: any;
  refetchCreditApp: any;
  creditApplication: any;
  userDocs: any;
  userDocsRefetch: any;
  portalConfigurationDataLoading: any;
  isCreditReportsHiddenForUserRole: any;
  isCreditReportDocumentsHiddenForUserRole: any;
  isIndividualCreditApp: boolean;
  tasksData: any;
  refetchDocs: any;
  isCreditAppNeedsRecertification: boolean;
  creditAppOwners: any[];
  contentViewType?: ContentViewType;
  goToCADView: VoidFunction;
  ocaTemplate: OcaTemplate;
  inventoryActions: {
    searchInventory: any;
    inventoryData: any;
    inventoryDataIsLoading: any;
    syncInventory: any;
    inventorySearchAccessData: any;
    inventorySearchAccessLoading: any;
    hasAccessToInventorySearch: any;
  };
}

export const CustomerSummaryCard_V2 = ({
  vo,
  refetchVO,
  vp,
  account,
  equipmentData,
  refetchEquipment,
  equipmentLoading,
  invoiceEquipmentTabPage,
  refetchCreditApp,
  creditApplication,
  userDocs,
  userDocsRefetch,
  portalConfigurationDataLoading,
  isCreditReportsHiddenForUserRole,
  isCreditReportDocumentsHiddenForUserRole,
  isIndividualCreditApp,
  tasksData,
  refetchDocs,
  contentViewType = ContentViewType.Desktop,
  isCreditAppNeedsRecertification,
  creditAppOwners,
  goToCADView,
  ocaTemplate,
  inventoryActions,
}: Props) => {
  const APPLICANT_OPEN_STATE_KEY: string = 'applicant';

  const classes = useStyles();
  const history = useHistory();

  const { isVOPaymentTypeUpdating, updateUpdatePaymentType, updateEquipmentCondition, isVOEquipmentConditionUpdating } =
    useVO();

  const { isLenderUser } = useContext(CommonDataContext);

  const currentUserProfile = useSelector((state: any) => state.userProfile);
  const recertificationPortalJSONConfig = useSelector(portalConfigurationsSelectors.recertificationJSONConfig);
  const isTiersResultsHidden = useSelector(portalConfigurationsSelectors.isTiersResultsHidden);

  const [doneRefetchingDocuments, setDoneRefetchingDocuments] = useState(false);
  const [documentIdToAutomaticallyOpen, setDocumentIdToAutomaticallyOpen] = useState(null);

  const [equipmentId, setEquipmentId] = useState('');
  const [openEquipmentInputModal, setOpenEquipmentInputModal] = useState(false);

  const { handleOpen: handleOpenConfirmationModal, handleClose: handleCloseConfirmationModal } = useModal(
    ModalsKeys.Confirmation
  );

  const [listItemOpenState, setListItemOpenState] = useState<any>({
    [APPLICANT_OPEN_STATE_KEY]: true,
  });

  const { hanldeSavingContact, handleSaveContactWithTaskCreation, includeContactInCreditApplication } =
    useManageContact();

  const { showNotification } = useNotifications();

  // Add Contact Modal
  const [isAddContactModalOpen, setIsAddContactModalOpen] = useState<boolean>(false);
  const [addContactModalLoading, setAddContactModalLoading] = useState<boolean>(false);
  const [isAuthLinkConfirmationModalOpen, setIsAuthLinkConfirmationModalOpen] = useState<boolean>(false);
  const [contactToSave, setContactToSave] = useState<ContactPayloadInput | null>(null);
  const [addAuthorizationTaskConfirmationTitle, setAddAuthorizationTaskConfirmationTitle] = useState<string>('');

  // Guarantee Contact Modal
  const [isGuaranteeContactModalOpen, setIsGuaranteeContactModalOpen] = useState<boolean>(false);
  const [isGuaranteeContactModalLoading, setIsGuaranteeContactModalLoading] = useState<boolean>(false);
  const [contactToAddGuaranteeFormValues, setContactToAddGuaranteeFormValues] = useState<any>(null);

  // Request Recertification Modal
  const [isRequestRecertificationModalOpen, setIsRequestRecertificationModalOpen] = useState<boolean>(false);
  const [isRequestRecertificationModalLoading, setIsRequestRecertificationModalLoading] = useState<boolean>(false);
  const [recertificationFormValues, setRecertificationFormValues] = useState<any>(null);

  // Add Corporate Guarantor Modal
  const { handleOpen: handleOpenCorporateGuarantorModal } = useModal(ModalsKeys.CorporateGuarantorDialog);

  const applicantName = creditApplication?.businessName || vo.potentialCustomer?.name;

  const corporateGuarantor = creditApplication?.references?.find(
    (r: Reference) => r.referenceType === ReferenceType.CorporateGuarantor
  );
  const corporateGuarantorSectionInOca = getSectionByReferenceType(ocaTemplate, ReferenceType.CorporateGuarantor);
  const isAddCorporateGuarantorAvailable = !corporateGuarantor && !!corporateGuarantorSectionInOca;

  let creditReportAlertComponent = null;

  const [updateCreditAppRequest] = useMutation(UPDATE_CREDIT_APPLICATION_V2_QUERY, {
    context: { authRequired: true },
  });

  const [upsertTask] = useMutation(UPSERT_TASK, {
    context: { authRequired: true },
  });

  const [uploadFile] = useMutation(UPLOAD_FILE);

  const [getDocuments] = useLazyQuery(Q_USER_DOCS);

  const modalsWithKeys: Partial<Record<ModalsKeys, ReactNode>> = {
    [ModalsKeys.CorporateGuarantorDialog]: <CorporateGuarantorModal />,
  };

  useEffect(() => {
    if (documentIdToAutomaticallyOpen && doneRefetchingDocuments) {
      setDoneRefetchingDocuments(false);
      if (documentIdToAutomaticallyOpen) {
        console.log(JSON.stringify(userDocs));
        const doc = userDocs.documents.find((d: any) => d.documentId === documentIdToAutomaticallyOpen);
        console.log(JSON.stringify(doc));
        if (doc) {
          // TODO: This if statement is reached but window.open() is not working. Popup blocker?
          window.open(doc.source, '_newtab');
        }
        return;
      }
      setDocumentIdToAutomaticallyOpen(null);
    }
  });

  const handleOpenCreditReportDocument = async (pgDetails: any, cbr: any) => {
    const getReportDoc = async () => {
      let reportDoc;
      reportDoc = userDocs.documents.find((d: any) => d.documentId === cbr.humanReadableReportDocumentId);
      if (!reportDoc) {
        // It means that user attempt to download a report from copied VO
        const { data } = await getDocuments({
          variables: {
            docId: cbr.humanReadableReportDocumentId,
          },
        });
        reportDoc = data.documents?.[0];
      }
      return reportDoc;
    };

    const reportDoc = await getReportDoc();
    if (reportDoc) {
      window.open(reportDoc.source, '_newtab');
    }
  };

  const openEquipmentInputModalFn = (equipmentId: string) => {
    setOpenEquipmentInputModal(true);
    setEquipmentId(equipmentId);
  };

  const handleViewDetailsClick = () => {
    goToCADView();
  };

  const handleEquipmentConditionChange = (nextEquipmentCondition: EquipmentCondition | string) => {
    const nextValue = nextEquipmentCondition as EquipmentCondition;

    if (!nextValue || nextValue === vo.equipmentCondition) return;

    handleOpenConfirmationModal({
      title: 'Change Equipment Condition?',
      message:
        'This action will reset your Stages and any existing stage data, checklists, or uploaded files will be lost.',
      onConfirm: async () => {
        handleCloseConfirmationModal();
        await updateEquipmentCondition(
          {
            voId: vo.vendorOpportunityId,
            nextEquipmentCondition: nextValue,
          },
          () => ({
            awaitRefetchQueries: true,
            refetchQueries: [bpfAPI.fetchVOTemplatesAndStages, Q_VO, Q_CREDIT_APP],
          })
        );
      },
    });
  };

  const handleIncludeInCreditApplicationClick = async (contact: any) => {
    try {
      await includeContactInCreditApplication(creditApplication.id, contact);
      await refetchCreditApp();
      showNotification('Success!');
    } catch (error) {
      console.error(error);
      showNotification('Error');
    }
  };

  const handleGuaranteeClick = (contact: any) => {
    const contactToAddGuaranteeFormValues: ContactFormValues = getContactToAddGuaranteeFormValues(contact);
    setContactToSave(contact);
    setContactToAddGuaranteeFormValues(contactToAddGuaranteeFormValues);
    setIsGuaranteeContactModalOpen(true);
  };

  const handleRecertifyClick = (e: SyntheticEvent) => {
    e.stopPropagation(); // to not cause row expanding
    setIsRequestRecertificationModalOpen(true);
    const recertificationFormValues: RecertificationFormValues = {
      ...iniitialRecertificationFormValues,
      recertificationDate: /* creditApplication.recertificationDate
        ? getDateTimeDisplayValue(creditApplication.recertificationDate, "yyyy-MM-dd'T'HH:mm")
        :  */ getDateTimeDisplayValue(Date.now(), "yyyy-MM-dd'T'HH:mm"),
    };
    setRecertificationFormValues(recertificationFormValues);
  };

  const handleSaveGuaranteeContactModal = async (contactFormValues: ContactFormValues) => {
    const initialValues = {
      ownerPgId: contactToSave?.ownerPgId,
      isOwnerPg: true,
      isOwnerPcOnly: false, // to appear in CADM ownership section
    };
    const updatedContactToSave: ContactPayloadInput = processFormValuesToPayload(contactFormValues, initialValues);
    setContactToSave(updatedContactToSave);
    setIsAuthLinkConfirmationModalOpen(true);
  };

  const handleSaveAddContactModal = async (contactFormValues: ContactFormValues, contactType: ContactType) => {
    const contactToSave: ContactPayloadInput = getContactToSave(creditApplication, contactFormValues, contactType);
    setContactToSave(contactToSave);
    if (contactType === 'contact-only') {
      setAddContactModalLoading(true);
      await hanldeSavingContact(contactToSave, creditApplication);
      await refetchCreditApp();
      setIsAddContactModalOpen(false);
      setAddContactModalLoading(false);
      setContactToSave(null);
      return;
    }

    const addAuthorizationTaskConfirmationTitle =
      contactType === 'signor-only'
        ? AddContactConfirmationModalTitle.SignorOnly
        : AddContactConfirmationModalTitle.SignorAndGuarantor;
    setAddAuthorizationTaskConfirmationTitle(addAuthorizationTaskConfirmationTitle);
    setIsAuthLinkConfirmationModalOpen(true);
  };

  const handleSaveRequestRecertificationModal = async (recertificationFormValues: RecertificationFormValues) => {
    const handleDocumentOrVerbalAuthorization = async () => {
      const creditAppInput = getCreditAppInputForDocumentOrVerbalAuthorization(
        creditApplication,
        recertificationFormValues,
        currentUserProfile
      );
      await updateCreditAppRequest({
        variables: {
          creditAppId: creditApplication.id,
          input: creditAppInput,
        },
      });
      if (recertificationFormValues.file) {
        await uploadFile({
          variables: {
            input: getRecertifiedCreditAppUploadFileInput(vo),
            file: recertificationFormValues.file,
          },
        });
      }
    };

    const handleRecertificationTasksCreation = async () => {
      const creditAppContactsByOwnerPgId = _.keyBy(creditAppOwners, 'ownerPgId');
      const createTasksPromises = recertificationFormValues.recertificationContactIds?.map(ownerId => {
        const contact = creditAppContactsByOwnerPgId[ownerId];
        const taskToCreate = getRecertificationTaskForContact(
          contact,
          vo.vendorOpportunityId,
          creditApplication.dynamicsId,
          account,
          currentUserProfile
        );
        return upsertTask({
          variables: {
            input: taskToCreate,
          },
        });
      });
      return Promise.all(createTasksPromises);
    };

    setIsRequestRecertificationModalLoading(true);
    recertificationFormValues.recertificationOption === 'send-task'
      ? await handleRecertificationTasksCreation()
      : await handleDocumentOrVerbalAuthorization();
    await refetchCreditApp();
    setIsRequestRecertificationModalOpen(false);
    setIsRequestRecertificationModalLoading(false);
  };

  const onAuthLinkConfirmationModalClose = async (event: any, reason: string) => {
    if (_.includes(['backdropClick', 'escapeKeyDown'], reason)) {
      return;
    }
    setIsAuthLinkConfirmationModalOpen(false);
    if (event.result !== 'ok') {
      return;
    }

    if (isAddContactModalOpen) {
      setAddContactModalLoading(true);
      await handleSaveContactWithTaskCreation(
        contactToSave!,
        creditApplication,
        vo.vendorOpportunityId!,
        refetchCreditApp
      );
      //await refetchTasks();
      setIsAddContactModalOpen(false);
      setAddContactModalLoading(false);
    }

    if (isGuaranteeContactModalOpen) {
      setIsGuaranteeContactModalLoading(true);
      await hanldeSavingContact(contactToSave, creditApplication);
      await refetchCreditApp();
      const taskToCreate = getNewSignorAndGuarantorSignatureTaskForContact(
        contactToSave,
        vo.vendorOpportunityId,
        creditApplication.dynamicsId,
        account,
        currentUserProfile
      );
      await upsertTask({
        variables: {
          input: taskToCreate,
        },
      });
      //await refetchTasks();
      setIsGuaranteeContactModalOpen(false);
      setIsGuaranteeContactModalLoading(false);
    }
    setContactToSave(null);
    setAddAuthorizationTaskConfirmationTitle('');
  };

  const handleCloseEquipmentInputModal = () => setOpenEquipmentInputModal(false);

  const handleCloseAddContactModal = () => {
    setIsAddContactModalOpen(false);
  };

  const handleCloseGuaranteeContactModal = () => {
    setIsGuaranteeContactModalOpen(false);
  };

  const handleCloseRequestRecertificationModal = () => {
    setIsRequestRecertificationModalOpen(false);
  };

  // hotfix: a workaround to be able to associate owner with appropriate result from GuarantorListWithCreditPull
  const guarantorListWithCreditPull: any = GuarantorListWithCreditPull({
    vo,
    creditApp: creditApplication,
    vp,
    refetchCreditApp,
    handleOpenCreditReportDocument,
    isCreditReportsHiddenForUserRole,
    isCreditReportDocumentsHiddenForUserRole,
  });
  const creditPullComponentByOwnerId = _.keyBy(guarantorListWithCreditPull, item => {
    if (_.isArray(item)) {
      return _.get(item, '[0].props.data-owner-pg-id');
    } else {
      creditReportAlertComponent = item;
    }
  });

  const getApplicantLayout = () => {
    // TODO: move into separate component
    if (_.isEmpty(vo) || _.isEmpty(creditApplication)) {
      return;
    }

    return (
      <>
        <ListItem
          disableGutters
          onClick={() => {
            setListItemOpenState((prev: any) => {
              return {
                ...prev,
                [APPLICANT_OPEN_STATE_KEY]: !prev[APPLICANT_OPEN_STATE_KEY],
              };
            });
          }}
          key={'applicant'}
        >
          <Grid container>
            <Grid item xs={6} style={{ display: 'flex' }}>
              <RowNameText text={'Applicant'} />
              {listItemOpenState[APPLICANT_OPEN_STATE_KEY] ? <ExpandLess /> : <ExpandMore />}
            </Grid>
            <Grid item xs={6} style={{ display: 'flex', alignItems: 'center' }}>
              <PermContactCalendarIcon fontSize="small" style={{ color: '#4994ec', marginRight: 8 }} />

              <Typography
                variant="body1"
                className={classes.link}
                onClick={() => {
                  history.push(`/accountDetails/${vo.potentialCustomer.id}`);
                }}
              >
                {applicantName}
              </Typography>

              {(!vp?.daysToCreditAppRecertification || isCreditAppNeedsRecertification) && (
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  style={{ marginLeft: 'auto' }}
                  onClick={handleRecertifyClick}
                >
                  Recertify
                </Button>
              )}
            </Grid>
          </Grid>
        </ListItem>

        <Divider />

        <Collapse in={listItemOpenState[APPLICANT_OPEN_STATE_KEY]} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {[...(creditAppOwners ?? []), ...(creditApplication.creditApplicationContacts ?? [])].map(
              (owner: CreditApplicationOwner) => {
                const phoneToDisplay = owner.phone || owner.mobilePhone || owner.homePhone || owner.workPhone;

                return (
                  <ApplicantInfo
                    owner={owner}
                    key={owner.ownerPgId}
                    phoneToDisplay={phoneToDisplay}
                    contentViewType={contentViewType}
                    creditPullComponentByOwnerId={creditPullComponentByOwnerId}
                    handleGuaranteeClick={handleGuaranteeClick}
                    handleIncludeInCreditApplicationClick={handleIncludeInCreditApplicationClick}
                  />
                );
              }
            )}
          </List>
        </Collapse>
      </>
    );
  };

  const getEquipmentDescription = () => {
    return equipmentData && _.some(equipmentData.equipments)
      ? _.map(equipmentData.equipments, item => {
          return (
            <a
              href="#"
              onClick={() => openEquipmentInputModalFn(item.equipmentId)}
              style={{ display: 'inline-block', color: theme.palette.primary.main }}
              key={`${item.equipmentId}${item.stockId}${item.make}${item.model}`}
            >
              {(item.quantity ? 'Qty ' + item.quantity : '') +
                (item.newUsed ? ', ' + item.newUsed : '') +
                (item.make ? ', ' + item.make : '') +
                (item.model ? ', ' + item.model : '') +
                (item.serialNumberVin ? ', SN/VIN#' + item.serialNumberVin : '') +
                (item.additionalDescription ? ', ' + item.additionalDescription : '') +
                (item.stockId ? ', ' + item.stockId : '')}
            </a>
          );
        })
      : _.get(vo, 'equipmentDescription');
  };

  const equipmentDescription = getEquipmentDescription();
  const isLoading = !creditApplication || !vo || !vp || portalConfigurationDataLoading;
  const isMarketingApproved = creditApplication?.primaryContact?.isMarketingApproved as 'true' | 'false' | null;

  return (
    <>
      <CardContainer
        title="Customer Summary"
        contentViewType={contentViewType}
        actionBtnProps={
          !isLoading
            ? {
                label: 'Credit Application Detail',
                onClick: handleViewDetailsClick,
              }
            : undefined
        }
      >
        {!isLoading && (
          <Typography className={classes.cardHeaderDateOfApplication}>
            Date of Application:{' '}
            {creditApplication.recertificationDate
              ? getDateTimeDisplayValue(creditApplication.recertificationDate, 'MM-dd-yyyy')
              : creditApplication.createdDateTime}
            {isCreditAppNeedsRecertification && <ErrorOutline className={classes.recertificationErrorIcon} />}
          </Typography>
        )}
        <CardContent style={{ padding: 0 }}>
          {isLoading ? (
            <LinearProgress style={{ width: '100%' }} />
          ) : (
            <>
              <List component="nav" aria-labelledby="nested-list-subheader">
                {getApplicantLayout()}

                {!isLenderUser && (
                  <PullCreditReportRow
                    vo={vo}
                    vp={vp}
                    creditApplication={creditApplication}
                    userDocs={userDocs}
                    userDocsRefetch={userDocsRefetch}
                    refetchCreditApp={refetchCreditApp}
                    setDoneRefetchingDocuments={setDoneRefetchingDocuments}
                    isIndividualCreditApp={isIndividualCreditApp}
                    isCreditReportsHiddenForUserRole={isCreditReportsHiddenForUserRole}
                    disableGutters={true}
                  />
                )}

                {!isTiersResultsHidden &&
                  vo?.creditTiersResult?.runtimeOutput?.event?.params?.financeProgram?.prescreenCriteria?.jsonCriteria?.find(
                    (criteria: any) => criteria?.name === vo?.creditTiersResult?.highestTierPassed
                  ) && (
                    <ListItem disableGutters>
                      <Grid container>
                        <Grid item xs={6}>
                          <RowNameText text="Internal Tier" />
                        </Grid>
                        <Grid item xs={6}>
                          <Stack alignItems="center" direction="row" gap="0.5rem">
                            <Box
                              sx={{
                                height: '1rem',
                                minWidth: '1rem',
                                borderRadius: '50%',
                                backgroundColor: vo?.creditTiersResult?.highestTierColor ?? green['500'],
                                border: '1px solid #ccc',
                                boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
                              }}
                            />
                            <RowValueText text={vo?.creditTiersResult?.highestTierPassed} />
                          </Stack>
                        </Grid>
                      </Grid>
                    </ListItem>
                  )}

                <Divider />

                <ListItem disableGutters>
                  <Grid container>
                    <Grid item xs={6}>
                      <RowNameText text={'Applicant Type'} />
                    </Grid>
                    <Grid item xs={6}>
                      <RowValueText text={isIndividualCreditApp ? 'Individual' : 'Commercial'} />
                    </Grid>
                  </Grid>
                </ListItem>
                <Divider />

                <ListItem disableGutters>
                  <Grid container>
                    <Grid item xs={6}>
                      <RowNameText text="Payment Type" />
                    </Grid>

                    <Grid item xs={6}>
                      <RenderWithCondition
                        fallBack={
                          <Typography>
                            {vo.paymentType
                              ?.toLowerCase()
                              ?.replace(/_/g, ' ')
                              ?.replace(/\b\w/g, (char: any) => char?.toUpperCase()) || '-'}
                          </Typography>
                        }
                        condition={[PaymentType.Cash, PaymentType.Financing].includes(vo.paymentType)}
                      >
                        <FormInputSelect
                          label="Payment Type"
                          defaultValue={vo.paymentType}
                          isLoading={isVOPaymentTypeUpdating}
                          onChange={async nextPaymentType => {
                            await updateUpdatePaymentType(
                              {
                                voId: vo.vendorOpportunityId,
                                nextPaymentType: nextPaymentType as PaymentType,
                              },
                              () => ({
                                awaitRefetchQueries: true,
                                refetchQueries: [bpfAPI.fetchVOTemplatesAndStages, Q_VO, Q_CREDIT_APP],
                              })
                            );
                          }}
                          options={[
                            { label: 'Cash', value: PaymentType.Cash },
                            { label: 'Financing', value: PaymentType.Financing },
                          ]}
                        />
                      </RenderWithCondition>
                    </Grid>
                  </Grid>
                </ListItem>
                <Divider />

                <ListItem disableGutters>
                  <Grid container>
                    <Grid item xs={6}>
                      <RowNameText text="Equipment Condition" />
                    </Grid>

                    <Grid item xs={6}>
                      <RenderWithCondition
                        condition={!!vo.equipmentCondition}
                        fallBack={<Typography>No Data</Typography>}
                      >
                        <FormInputSelect
                          label="Equipment Condition"
                          value={vo.equipmentCondition}
                          isLoading={isVOEquipmentConditionUpdating}
                          onChange={handleEquipmentConditionChange}
                          options={[
                            { label: 'New', value: EquipmentCondition.New },
                            { label: 'Used', value: EquipmentCondition.Used },
                            { label: 'Reconditioned', value: EquipmentCondition.Reconditioned },
                          ]}
                        />
                      </RenderWithCondition>
                    </Grid>
                  </Grid>
                </ListItem>
                <Divider />

                {creditApplication.applyingFor && (
                  <>
                    <ListItem disableGutters>
                      <Grid container>
                        <Grid item xs={6}>
                          <RowNameText text={'Applying For'} />
                        </Grid>
                        <Grid item xs={6}>
                          <RowValueText
                            text={_(creditApplication.applyingFor)
                              .map((item: string) => FINANCING_TYPE[item as keyof typeof FINANCING_TYPE] || item)
                              .join(', ')}
                          />
                        </Grid>
                      </Grid>
                    </ListItem>
                    <Divider />
                  </>
                )}
                <ListItem disableGutters>
                  <Grid container>
                    <Grid item xs={6}>
                      <RowNameText text={'Type'} />
                    </Grid>
                    <Grid item xs={6}>
                      <RowValueText text={OpportunityTypes[vo.entityType as keyof typeof OpportunityTypes]} />
                    </Grid>
                  </Grid>
                </ListItem>
                <Divider />
                <ListItem disableGutters>
                  <Grid container>
                    <Grid item xs={6}>
                      <RowNameText text={'Amount'} />
                    </Grid>
                    <Grid item xs={6}>
                      <RowValueText
                        text={vo.invoiceTotal || vo.invoiceTotal === 0 ? formatCurrency(vo.invoiceTotal) : '-'}
                      />
                    </Grid>
                  </Grid>
                </ListItem>
                <Divider />
                <ListItem disableGutters>
                  <Grid container>
                    <Grid item xs={6}>
                      <RowNameText text={'Equipment Description'} />
                    </Grid>
                    <Grid item xs={6}>
                      <RowValueText text={equipmentDescription || '-'} />
                    </Grid>
                  </Grid>
                </ListItem>
                {vo.contactFormNotes && (
                  <>
                    <Divider />
                    <ListItem disableGutters>
                      <Grid container>
                        <Grid item xs={6}>
                          <RowNameText text={'Message to Dealer'} />
                        </Grid>
                        <Grid item xs={6}>
                          <RowValueText text={vo.contactFormNotes} />
                        </Grid>
                      </Grid>
                    </ListItem>
                  </>
                )}
                {vo.partnerName && (
                  <>
                    <Divider />
                    <ListItem disableGutters>
                      <Grid container>
                        <Grid item xs={6}>
                          <RowNameText text={'Source'} />
                        </Grid>
                        <Grid item xs={6}>
                          <RowValueText text={vo.partnerName} />
                          {vo.sourceUrl && (
                            <>
                              <br />
                              <a href={vo.sourceUrl} target="_blank" rel="noreferrer">
                                Source URL
                              </a>
                            </>
                          )}
                        </Grid>
                      </Grid>
                    </ListItem>
                  </>
                )}

                <RenderWithCondition condition={vo.entityType === CreditApplicationEntityType.LeadProposal}>
                  <SourceRow vo={vo} />
                </RenderWithCondition>

                <Divider />
                <ListItem disableGutters>
                  <Grid container>
                    <Grid item xs={6}>
                      <RowNameText text="Marketing Communications" />
                    </Grid>
                    <Grid item xs={6}>
                      <RowValueText
                        text={isMarketingApproved ? (isMarketingApproved === 'true' ? 'Yes' : 'No') : '-'}
                      />
                    </Grid>
                  </Grid>
                </ListItem>
              </List>
              <CardActions>
                {isAddCorporateGuarantorAvailable && (
                  <Button
                    size="small"
                    color="primary"
                    variant="contained"
                    startIcon={<AddCircle />}
                    onClick={() =>
                      handleOpenCorporateGuarantorModal({ creditApplication, ocaTemplate, refetchCreditApp })
                    }
                  >
                    Add Corporate Guarantor
                  </Button>
                )}
                <Button
                  size="small"
                  color="primary"
                  variant="contained"
                  startIcon={<AddCircle />}
                  onClick={() => setIsAddContactModalOpen(true)}
                >
                  Add Contact
                </Button>
              </CardActions>
            </>
          )}
        </CardContent>
      </CardContainer>

      {React.isValidElement(creditReportAlertComponent) && creditReportAlertComponent}

      <Modal
        open={openEquipmentInputModal}
        onClose={handleCloseEquipmentInputModal}
        aria-labelledby="Equipment Input Modal"
        aria-describedby="Input"
      >
        <div>
          {vp && equipmentId && (
            <EquipmentInputModal
              vo={vo}
              creditApplication={creditApplication}
              equipmentLoading={equipmentLoading}
              equipmentData={equipmentData}
              handleClose={handleCloseEquipmentInputModal}
              refetchVO={refetchVO}
              equipmentId={equipmentId}
              refetch={refetchEquipment}
              vendorProfile={vp}
              refetchCreditApp={refetchCreditApp}
              invoiceEquipmentTabPage={invoiceEquipmentTabPage}
              refetchDocs={refetchDocs}
              account={account}
              inventoryActions={inventoryActions}
            />
          )}
        </div>
      </Modal>

      <ContactModal
        isOpen={isAddContactModalOpen}
        isLoading={addContactModalLoading}
        mode="add-contact"
        onClose={handleCloseAddContactModal}
        onSave={handleSaveAddContactModal}
      />

      <ContactModal
        isOpen={isGuaranteeContactModalOpen}
        isLoading={isGuaranteeContactModalLoading}
        mode="guarantee"
        defaultContactType="signor-and-guarantor"
        defaultFormValues={contactToAddGuaranteeFormValues}
        onClose={handleCloseGuaranteeContactModal}
        onSave={handleSaveGuaranteeContactModal}
      />

      <ConfirmationDialog
        title={addAuthorizationTaskConfirmationTitle}
        messageLayout={() => <AuthorizationTaskConfirmationBodyLayout contactToSave={contactToSave!} />}
        loading={false}
        open={isAuthLinkConfirmationModalOpen}
        okButtonText="Confirm"
        cancelButtonText="Cancel"
        onClose={onAuthLinkConfirmationModalClose}
      />

      <RequestRecertificationModal
        isOpen={isRequestRecertificationModalOpen}
        onClose={handleCloseRequestRecertificationModal}
        onSave={handleSaveRequestRecertificationModal}
        isLoading={isRequestRecertificationModalLoading}
        vendorOpportunityTasks={tasksData?.vendorOpportunityTask}
        defaultFormValues={recertificationFormValues}
        creditAppOwners={creditAppOwners}
        portalConfiguration={recertificationPortalJSONConfig}
      />

      <ModalsContainer modalsWithKeys={modalsWithKeys} />
    </>
  );
};

const RowValueText = ({ text, typographyProps }: { text: string; typographyProps?: any }) => {
  const classes = useStyles();

  return (
    <Typography className={classes.listRowValue} {...typographyProps}>
      {text || ''}
    </Typography>
  );
};

const useStyles = makeStyles(theme => ({
  link: {
    cursor: 'pointer',
    color: theme.palette.primary.main,
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  listRowValue: {
    color: '#212121',
  },
  card: {
    margin: 0,
    height: '100%',
    width: '100%',

    '& .MuiCardHeader-action': {
      margin: 0,
    },
    '& .MuiCardContent-root': {
      paddingTop: 0,
    },
  },
  cardHeader: {
    margin: '10px 10px 0 10px',
  },
  cardHeaderDateOfApplication: {
    display: 'flex',
    justifyContent: 'flex-end',
    color: '#666666',
  },
  recertificationErrorIcon: {
    color: 'red',
    fontSize: 22,
    marginLeft: 5,
  },
}));
